import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isValidUUID = (id: string) => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

export function getAvatarColor(name: string): string {
  if (!name) return "bg-muted text-muted-foreground";

  const colors = [
    "bg-red-500/10 text-red-600 dark:text-red-400 dark:bg-red-500/20",
    "bg-orange-500/10 text-orange-600 dark:text-orange-400 dark:bg-orange-500/20",
    "bg-amber-500/10 text-amber-600 dark:text-amber-400 dark:bg-amber-500/20",
    "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 dark:bg-emerald-500/20",
    "bg-teal-500/10 text-teal-600 dark:text-teal-400 dark:bg-teal-500/20",
    "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 dark:bg-cyan-500/20",
    "bg-sky-500/10 text-sky-600 dark:text-sky-400 dark:bg-sky-500/20",
    "bg-blue-500/10 text-blue-600 dark:text-blue-400 dark:bg-blue-500/20",
    "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 dark:bg-indigo-500/20",
    "bg-violet-500/10 text-violet-600 dark:text-violet-400 dark:bg-violet-500/20",
    "bg-purple-500/10 text-purple-600 dark:text-purple-400 dark:bg-purple-500/20",
    "bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-400 dark:bg-fuchsia-500/20",
    "bg-pink-500/10 text-pink-600 dark:text-pink-400 dark:bg-pink-500/20",
    "bg-rose-500/10 text-rose-600 dark:text-rose-400 dark:bg-rose-500/20",
  ];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
